import { Campaign, CampaignBody } from "@vviinn/user-managment-client-ts";
import {
  campaignNetsKeys,
  similarityNumericSettings,
} from "../../../../constants";

const handleTextNets = (defaultPresetValues: CampaignBody) => {
  const hasDefaults =
    defaultPresetValues.imageWeights !== undefined ||
    defaultPresetValues.productWeights !== undefined;
  if (!hasDefaults) return {};
  return {
    imageWeights: defaultPresetValues.imageWeights,
    productWeights: defaultPresetValues.productWeights,
  };
};

const handleNets = (campaign: Campaign, defaultPresetValues: CampaignBody) => {
  const hasRelevantNets = campaignNetsKeys.reduce(
    (acc, key) => acc || !!defaultPresetValues[key],
    false,
  );
  if (!hasRelevantNets) return {};
  const keysToUpdate = campaignNetsKeys.filter(
    (netKey) => campaign[netKey] || defaultPresetValues[netKey],
  );

  return Object.fromEntries(
    keysToUpdate.map((netKey) => [netKey, defaultPresetValues[netKey] ?? 0]),
  );
};

export const handleAIReset = (
  campaign: Campaign,
  defaultPresetValues: CampaignBody,
) => {
  const updatedNets =
    campaign.type === "TEXT_SEARCH"
      ? handleTextNets(defaultPresetValues)
      : handleNets(campaign, defaultPresetValues);
  const updatedSimilarity = Object.fromEntries(
    similarityNumericSettings
      .filter((key) => defaultPresetValues[key] !== undefined)
      .map((key) => [key, defaultPresetValues[key]]),
  );
  return { updatedNets, updatedSimilarity };
};
